// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O1Uk4p {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
}

.AyL6TP {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

.P4GhFa {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.YkxFR7 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.QViiHu {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--vscode-foreground);
  margin: 0;
}

.hHcoKB {
  font-size: 1rem;
  color: var(--vscode-descriptionForeground);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/DeliveryAddress/DeliveryAddress.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,SAAS;AACX","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding: 2rem;\n}\n\n.cardIllustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.cardImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.explanation {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--vscode-foreground);\n  margin: 0;\n}\n\n.subtitle {\n  font-size: 1rem;\n  color: var(--vscode-descriptionForeground);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `O1Uk4p`,
	"cardIllustration": `AyL6TP`,
	"cardImage": `P4GhFa`,
	"explanation": `YkxFR7`,
	"title": `QViiHu`,
	"subtitle": `hHcoKB`
};
module.exports = ___CSS_LOADER_EXPORT___;
